import { FalhaServico } from '../falha-servico';

export class InformacaoCadastro{
    nome: string;
    cpf: string;
    situacao: string;
    documentoIdentificacao: string;
    nomeMae: string;
    dataNascimento: string;
    endereco: string;
    bairro: string;
    cep: string;
    cidade: string;
    uf: string;
    telefone: string;
    email: string;
    vip: boolean;
    falhaServico: FalhaServico;

    constructor(){
        this.falhaServico = new FalhaServico();
    }
}